import { defa }          from 'defa-object';
import ControlModel      from 'scripts/poppet/control-model';

/**
 * defa.models.HeatingSwitch
 * The DEFA HeatingSwitch model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	heatingSwitch: '/homeAutomation/masterControl?attrs=',
};


const HeatingSwitch = ControlModel.extend( {

	url: function() {
		return api.linkcom + this.get('id') + api.heatingSwitch + this.getAttributes();
	},
	
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({}, ControlModel.prototype.defaults,
		{
			heatingSwitch: null,
			heatingSwitchError: null,
		
		}),
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	parse: function( response, options ) {
		if(response) {
			let newModelAttributes = {};
			if(response.heatingSwitch){
				this.parseAttribute('heatingSwitch', response.heatingSwitch, options, newModelAttributes)
			}
			newModelAttributes.modelError = null;
			this.receivedData( newModelAttributes );
			channel.request( 'heatingSwitchs' ).add( newModelAttributes, { merge: true } );
		}
	},

	toBackendJSON() {
		return { heatingSwitch: 'Home' === this.get('heatingSwitch') };
	},

	getAttributes: function() {
		return 'heatingSwitch';
	},
	
	/**
	 * Returns an array of dependent models that will be fetched after this model is saved.
	 * Only zones that is not disabled and has follow master switch enabled will be updated.
	 */
	_getDependentModels: function(){
		let self = this;
		let dependentModels = [];
		let allZones = channel.request('zoneHolders').get(self.get('id')).get('zones');
		for(let index in allZones){
			let mode = allZones[index].getModel('5').get('zoneMode');
			let followMaster = allZones[index].getModel('5').get('followMaster');
			if(mode !== 'disabled' && followMaster){
				dependentModels.push(allZones[index].getModel('1'));
				if('thermostat' === mode){
					dependentModels.push(allZones[index].getModel('3'));
				}else if('regulator'=== mode){
					dependentModels.push(allZones[index].getModel('4'));
				}
			}
		}
		return dependentModels;
	},
	
} );

export default HeatingSwitch;
